import type { DropdownData } from '@fitogest/reactive-form-builder/interfaces';
import { list } from '../../../../../common/classes/request-builder';
import { SectorModel } from 'src/app/models/form-common/sector.model';

export class SectoresListsDefinition {
  distanciasGoteros: DropdownData<string> =  list(
      ['...', null],
      '25cm',
      '30cm',
      '50cm',
      '95cm',
      '100cm'
  );

  fincas: DropdownData<SectorModel> = {
      filtered: [{label: '...', value: null}],
      values: []
  };

  jardines: DropdownData<SectorModel> = list<SectorModel>(['...', null]);
}
